import { createSelector } from '@ngrx/store';
import * as RA from 'ramda-adjunct';
import { getMenuState, MenuState } from '../menu.reducer';
import { adapter, LocationSetsState } from './location-sets.reducer';
import {asyncActionState} from '@emm/core/util/async-action-state';
import {LocationSetTypesSelectors} from '@emm/menu/store/location-set-types/location-set-types.selectors';
import {LocationSet} from '@emm/core/models/location-set.model';


const getState = createSelector(getMenuState, (state: MenuState) => state?.locationSets);

const entitySelectors = adapter.getSelectors(getState);
const asyncActionStateSelectors = asyncActionState.getSelectors(getState);

const getSelectedTag = createSelector(getState, (state: LocationSetsState) => state.selectedTag);

const getSelected = createSelector(
    entitySelectors.selectEntities,
    getSelectedTag,
    (entities, selectedTag) => selectedTag && entities[selectedTag]
);

const filteredByCurrentScope = createSelector(
    entitySelectors.selectAll,
    LocationSetTypesSelectors.getSelected,
    (items, selectedLocationSetType) =>
        selectedLocationSetType
            ? items.filter((item) => item.scope === selectedLocationSetType.name)
            : []
);

const getValidFilteredByCurrentScope = createSelector(
    filteredByCurrentScope,
    asyncActionStateSelectors.getHasError,
    asyncActionStateSelectors.getSuccess,
    (items, hasError, success) => (!hasError && success ? items : null)
);

const getIsChainMenu = createSelector(
    LocationSetTypesSelectors.getSelectedTag,
    getSelectedTag,
    (locationSetTypeTag, locationSetTag) =>
        RA.isNonEmptyString(locationSetTypeTag) &&
        RA.isNonEmptyString(locationSetTag) &&
        locationSetTypeTag === 'CHAIN' &&
        locationSetTag === 'CHAIN'
);

const getFilter = createSelector(getState, (state) => state.filter);

const getSelectedVenue = createSelector(getState, (state) => state.selectedVenue);

const getFilteredLocationSets = createSelector(
    getValidFilteredByCurrentScope,
    getFilter,
    LocationSetTypesSelectors.getDisplayResultsImmediately,
    LocationSetTypesSelectors.getIsLocationSetTypeParent,
    (
        locationSets: LocationSet[],
        filter: string,
        displayResultsImmediately: boolean,
        isLocationSetTypeParent: boolean
    ) => {
        let filterLocationSets: LocationSet[] = [];

        if (RA.isNonEmptyArray(locationSets)) {
            filterLocationSets =
                !isLocationSetTypeParent && RA.isNonEmptyString(filter)
                    ? locationSets.filter((locationSet) =>
                        RA.isValidNumber(+filter)
                            ? locationSet.tag.includes(filter)
                            : locationSet.name.toLowerCase().includes(filter.toLowerCase())
                    )
                    : locationSets;
        }

        return filterLocationSets.length < 25 || displayResultsImmediately ? filterLocationSets : [];
    }
);

export const LocationSetsSelectors = {
    entitySelectors,
    ...asyncActionStateSelectors,
    filteredByCurrentScope,
    getFilter,
    getFilteredLocationSets,
    getIsChainMenu,
    getSelected,
    getSelectedTag,
    getValidFilteredByCurrentScope,
    getSelectedVenue
};
